import { TextPaperStatus } from '@ui/elements/TextPaper/types'
import { CustomerDetailSection } from '@ca/common'

export const hasTextPaperLines = (
  lines: (string | undefined | null)[]
): boolean => lines.some((line) => !!line?.trim())

export const getTextPaperStatus = ({
  isEmpty,
  isValid,
  isConfirmed,
  hasAttemptedConfirm,
  section,
  savedDetailSections,
}: {
  isEmpty: boolean
  isValid: boolean
  isConfirmed: boolean | undefined
  hasAttemptedConfirm: boolean
  section?: CustomerDetailSection
  savedDetailSections?: CustomerDetailSection[]
}): TextPaperStatus => {
  const isSectionSaved =
    section !== undefined && !!savedDetailSections?.includes(section)

  if (!isEmpty && isValid && (isConfirmed || isSectionSaved)) {
    return 'success'
  }
  if (hasAttemptedConfirm && !isValid) {
    return 'danger'
  }
  if (isEmpty) {
    return 'empty'
  }
  return 'default'
}
